import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { PageHeaderComponent } from './page-header/page-header.component';
import { UsersMenuComponent } from './page-header/users-menu/users-menu.component';
import { ResourcesHeaderComponent } from './resources-header/resources-header.component';
import { ResourcesMenuComponent } from './page-header/resources-menu/resources-menu.component';
import { ResponsiveMenuComponent } from './page-header/responsive-menu/responsive-menu.component';
import { ResourcesFilterComponent } from './resources-filter/resources-filter.component';
import { MenuPopoverComponent } from './menu-popover/menu-popover.component';
import { PagesNavigationComponent } from './pages-navigation/pages-navigation.component';
import { BlogNavigationComponent } from './blog-navigation/blog-navigation.component';
import { ArticleComponent } from './article/article.component';
import { AccessCodePopoverComponent } from './access-code-popover/access-code-popover.component';
import { MessagePopoverComponent } from './message-popover/message-popover.component';
import { SongDetailComponent } from './song-detail/song-detail.component';
import { TeachingToolComponent } from './teaching-tool/teaching-tool.component';
import { SpinnerOverlayComponent } from './spinner-overlay/spinner-overlay.component';
import { PageHeaderCommands } from './page-header/page-header.commands';
import { ScrollBounceDirective } from './scroll-bounce/scroll-bounce.directive';
import { AutofocusDirective } from './auto-focus/auto-focus.directive';
import { DatePopoverComponent } from './date-popover/date-popover.component';
import { PdfViewPopupComponent } from './pdf-view-popup/pdf-view-popup.component';
import { MoveCopyLessonComponent } from './move-copy-lesson/move-copy-lesson.component';
import { CacheNotificationComponent } from './cache-notification/cache-notification.component';

@NgModule({
    declarations: [
        PageHeaderComponent,
        UsersMenuComponent,
        ResourcesHeaderComponent,
        ResourcesMenuComponent,
        ResponsiveMenuComponent,
        ResourcesFilterComponent,
        MenuPopoverComponent,
        PagesNavigationComponent,
        BlogNavigationComponent,
        ArticleComponent,
        AccessCodePopoverComponent,
        MessagePopoverComponent,
        SongDetailComponent,
        TeachingToolComponent,
        SpinnerOverlayComponent,
        ScrollBounceDirective,
        AutofocusDirective,
        DatePopoverComponent,
        PdfViewPopupComponent,
        MoveCopyLessonComponent,
        CacheNotificationComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule
    ],
    exports: [
        PageHeaderComponent,
        UsersMenuComponent,
        ResourcesHeaderComponent,
        ResourcesMenuComponent,
        ResponsiveMenuComponent,
        ResourcesFilterComponent,
        MenuPopoverComponent,
        PagesNavigationComponent,
        BlogNavigationComponent,
        ArticleComponent,
        AccessCodePopoverComponent,
        MessagePopoverComponent,
        SongDetailComponent,
        TeachingToolComponent,
        SpinnerOverlayComponent,
        ScrollBounceDirective,
        AutofocusDirective,
        DatePopoverComponent
    ],
    
    // entryComponents: [ // not in a routing, so must add explicitly
    //     UsersMenuComponent,
    //     ResourcesHeaderComponent,
    //     ResourcesMenuComponent,
    //     ResponsiveMenuComponent,
    //     ResourcesFilterComponent,
    //     MenuPopoverComponent,
    //     PagesNavigationComponent,
    //     BlogNavigationComponent,
    //     ArticleComponent,
    //     AccessCodePopoverComponent,
    //     MessagePopoverComponent,
    //     SongDetailComponent,
    //     TeachingToolComponent,
    //     SpinnerOverlayComponent,
    // ],
    providers: [
        PageHeaderCommands,
    ]
})
export class ComponentsModule { }
